export default "__VITE_ASSET__BTvYPpYH__"